import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import styles from './styles.module.scss';

export const UpdateModal = ({
  cartUpdateMessage,
  confirmationMessage,
  confirm,
}) => {
  return (
    <div className={styles.updateModal}>
      <div className={styles.updateModalContent}>
        <p className={styles.message}>{cartUpdateMessage}</p>
        <button className={styles.button} onClick={confirm}>
          {confirmationMessage}
        </button>
      </div>
    </div>
  );
};

UpdateModal.propTypes = {
  cartUpdateMessage: PropTypes.string.isRequired,
  confirmationMessage: PropTypes.string.isRequired,
  confirm: PropTypes.func.isRequired,
};

export default enhance(UpdateModal);
